import { render, staticRenderFns } from "./BemMovel.vue?vue&type=template&id=10ce0aa6"
import script from "./BemMovel.vue?vue&type=script&lang=js"
export * from "./BemMovel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports